import * as BaseApi from "api/Base.api";
import { IUserStudent } from "api/interfaces/user.interface";

const BASE_URL = "/student/v2/rank";

export interface IRankHomeInfo {
    castingMangerViewCountRankList: IUserStudent[],
    favoriteCountRankList: IUserStudent[],
}

//* 지망생 랭킹 정보 조회
//  2025-01-XX 추가
//  희문
//* Params
//  없음
export const getRankHomeInfo = async () => {
    return await BaseApi.get(`${BASE_URL}`);
};
